// @flow
import React, { Fragment } from 'react';
import GrayBoxes from '../../common/GrayBoxes';
import './ProductPlaceholder.scss';
import ProductCategories from '../ProductCategories/ProductCategories';

const ProductPlaceholder = () => (
  <Fragment>
    <ProductCategories.Placeholder />
    <div className="ProductPlaceholder">
      <div className="content-head">
        <div className="product-thumbnail" />
        <div className="separator" />
        <div className="product-info">
          <div className="header">
            <div className="gray-block supplier-name" />
          </div>
          <div className="gray-block title" />
          <div className="share-and-likes">
            <div className="gray-block likeBtn" />
            <div className="gray-block shareBtn" />
          </div>
          <div className="banner gray-block" />
          <div className="price-info">
            <div className="gray-block vat" />
            <div className="gray-block price" />
          </div>
          <div className="separator-x" />
          <div className="sale-brand">
            <div className="gray-block" />
            <div className="gray-block" />
          </div>
          <div className="separator-x" />
          <div className="buttons">
            <div className="gray-block" />
            <div className="gray-block" />
            <div className="gray-block" />
          </div>
          <div className="event gray-block" />
        </div>
      </div>
      <div className="gray-block product-prices" />
      <div className="content-body">
        <div className="gray-block product-title" />
        <GrayBoxes countMin={20} countMax={40} sizeMin={4} sizeMax={10} />
        <div className="line-breaker" />
        <GrayBoxes countMin={20} countMax={40} sizeMin={4} sizeMax={10} />
        <div className="line-breaker" />
        <GrayBoxes countMin={20} countMax={40} sizeMin={4} sizeMax={10} />
      </div>
    </div>
  </Fragment>
);

export default ProductPlaceholder;



// WEBPACK FOOTER //
// ./src/components/product/ProductPlaceholder/ProductPlaceholder.js